import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        body: {
          // Firefox
          scrollbarWidth: 'thin',
          scrollbarColor: '#bdbdbd #f5f5f5',
        },
        '*::-webkit-scrollbar': {
          width: '7px',
          height: '7px',
        },
        '*::-webkit-scrollbar-thumb': {
          backgroundColor: '#bdbdbd',
          borderRadius: '6px',
        },
        '*::-webkit-scrollbar-thumb:hover': {
          backgroundColor: '#a0a0a0',
        },
        '*::-webkit-scrollbar-track': {
          background: '#f5f5f5',
          borderRadius: '6px',
        },
        // Extra specificity for MUI TableContainer and Paper
        '.MuiPaper-root, .MuiTableContainer-root': {
          scrollbarWidth: 'thin',
          scrollbarColor: '#bdbdbd #f5f5f5',
        },
        '.MuiPaper-root::-webkit-scrollbar, .MuiTableContainer-root::-webkit-scrollbar': {
          width: '7px',
          height: '7px',
        },
        '.MuiPaper-root::-webkit-scrollbar-thumb, .MuiTableContainer-root::-webkit-scrollbar-thumb': {
          backgroundColor: '#bdbdbd',
          borderRadius: '6px',
        },
        '.MuiPaper-root::-webkit-scrollbar-thumb:hover, .MuiTableContainer-root::-webkit-scrollbar-thumb:hover': {
          backgroundColor: '#a0a0a0',
        },
        '.MuiPaper-root::-webkit-scrollbar-track, .MuiTableContainer-root::-webkit-scrollbar-track': {
          background: '#f5f5f5',
          borderRadius: '6px',
        },
      },
    },
  },
});

export default theme;
